import {
  gatewaysSection,
  logsSection,
  policiesSection,
  targetsSection,
} from "./pamSections";
import { AppWindow, ChevronRight, Database, IdCardLanyard, Lock, Network } from "lucide-react";

// PAM mode. The five capability sections come from ./pamSections so this file
// and mfa/mfaPamNavigation.js cannot drift; the blocks below are the surfaces
// that only this mode shows.
const pamNavigation = [
  gatewaysSection,
  targetsSection,
  policiesSection,
  // credentialsSection,  ← re-enable when Credentials ships
  logsSection,

  {
    key: "/pam/users",
    icon: <IdCardLanyard className="icon" />,
    label: "Identities",
    navigate: "/pam/users",
    expandIcon: ({ isOpen }) => (
      <ChevronRight
        className={`icon transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`}
      />
    ),
    children: [
      { key: "/pam/users", label: "Users", navigate: "/pam/users", },
      { key: "/pam/directory", label: "Identity Sources", navigate: "/pam/directory", },
    ]
  },
  {
    key: "/pam/radius",
    icon: <Network className="icon" />,
    label: "Network Devices",
    navigate: "/pam/radius",
  },
  {
    key: "/pam/databases",
    icon: <Database className="icon" />,
    label: "Databases",
    navigate: "/pam/databases",
    expandIcon: ({ isOpen }) => (
      <ChevronRight
        className={`icon transition-transform duration-200 ${isOpen ? 'rotate-90' : ''}`}
      />
    ),
    children: [
      { key: "/pam/databases/dashboard", label: "Dashboard", navigate: "/pam/databases/dashboard" },
      { key: "/pam/databases/agents", label: "Agents", navigate: "/pam/databases/agents" },
      { key: "/pam/databases", label: "Databases", navigate: "/pam/databases" },
      { key: "/pam/databases/users", label: "Users", navigate: "/pam/databases/users" },
      { key: "/pam/databases/connections", label: "Connections", navigate: "/pam/databases/connections" },
    ]
  },
  {
    key: "/pam/apps",
    icon: <AppWindow className="icon" />,
    label: "Apps",
    navigate: "/pam/apps",
  },
  {
    key: "/windows/accountLockoutEvents",
    icon: <Lock className="icon" />,
    label: "Account Lockout Events",
    navigate: "/windows/accountLockoutEvents",
  },

];

export default pamNavigation;
